export default "__VITE_ASSET__FjZoJMxaNBfr5eOkud6aIw__"